import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkAuditLog} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {AuditLogDocumentTitle} from 'src/app/audit-logs/auditLogHelpers';
import {AuditLogsTable} from 'src/app/audit-logs/AuditLogsTable';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {AuditLogsViewType} from 'src/shared/constants/ViewTypes';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useUrlQueryTabV2} from 'src/shared/hooks/useUrlQueryTabV2';
import DeepSearchTab from './components/DeepSearchTab/DeepSearchTab';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const AuditLogsListPage: React.FC = () => {
  useSetDocumentTitle(AuditLogDocumentTitle);

  const navigate = useAppNavigate();
  const {view} = useParams();

  const {RenderedTabsComponent} = useUrlQueryTabV2<AuditLogsViewType>({
    view: (view ?? 'list') as AuditLogsViewType,
    defaultView: 'list',
    tabs: [
      {
        view: 'list',
        label: 'List',
        component: <AuditLogsTable />,
      },
      {
        view: 'deep-search',
        label: 'Deep Search',
        component: <DeepSearchTab />,
      },
    ],
    onSelectView: view => {
      navigate(PathUtility.AuditLogsWithView(view as AuditLogsViewType));
    },
  });

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.AuditLogs}>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkAuditLog.icon}
          subtitle="View system activity and changes">
          Audit Logs
        </PageHeader.Title>
      </PageHeader>
      {RenderedTabsComponent}
    </ContentWrapper>
  );
};

// Register the routes with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AuditLogsWithView(':view'),
  element: <AuditLogsListPage />,
  module: ModuleEnum.AuditLog,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AuditLogs(),
  element: <AuditLogsListPage />,
  module: ModuleEnum.AuditLog,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default AuditLogsListPage;
